import Pinterest from '../../src/legacy/Pinterest.tsx';
export default Pinterest;
